import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import PageLoading from '../components/loading/page';

const AuthRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isLoading, isInitialized } = useSelector(state => state.loggedInUser);

  useEffect(() => {
    if (isInitialized && !user) {
      navigate('/login', { replace: true, state: { path: location.pathname } });
    }
  }, [user, isInitialized, navigate, location.pathname]);

  if (isLoading || !isInitialized) {
    return <PageLoading />;
  }

  return children;
};

export default AuthRoute;